export const AUTH_DATA_NAME = 'data';
export const AUTH_DATA_PREFIX = '@@auth';

export const AUTH_MODAL_NAME = 'authModal';
export const AUTH_MODAL_PREFIX = `@@${AUTH_MODAL_NAME}`;

export const LOGIN_USER_NAME = 'loginUser';
export const LOGIN_USER_PREFIX = `@@${LOGIN_USER_NAME}`;

export const REFRESH_USER_NAME = 'refreshUser';
export const REFRESH_USER_PREFIX = `@@${REFRESH_USER_NAME}`;

export const RESET_PASSWORD_NAME = 'resetPassword';
export const RESET_PASSWORD_PREFIX = `@@${RESET_PASSWORD_NAME}`;

export const SIGNUP_USER_NAME = 'signupUser';
export const SIGNUP_USER_PREFIX = `@@${SIGNUP_USER_NAME}`;



// WEBPACK FOOTER //
// ./src/js/auth/redux/state.js